import { Injectable, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

export type AnnouncerPoliteness = 'polite' | 'assertive';

@Injectable({ providedIn: 'root' })
export class AnnouncerService {
  private readonly document = inject(DOCUMENT);

  announce(message: string, politeness: AnnouncerPoliteness = 'polite'): void {
    const id = politeness === 'assertive' ? 'announcer-assertive' : 'announcer';
    const element = this.document.getElementById(id);
    if (element) {
      element.textContent = '';
      setTimeout(() => {
        element.textContent = message;
      }, 50);
    }
  }

  announcePolite(message: string): void {
    this.announce(message, 'polite');
  }

  announceAssertive(message: string): void {
    this.announce(message, 'assertive');
  }
}